window.ReferralUtils = {
    data: {
        utm_source: undefined,
        utm_campaign: undefined
    },
    parseUTMParams: function() {
        ReferralUtils.data['utm_source'] = getParameterByName('utm_source', window.location.href);

        if (ReferralUtils.data['utm_source']) {
            ReferralUtils.data['utm_campaign'] = getParameterByName('utm_campaign', window.location.href);
        }
    },
    isMobile: function () {
        var isAndroid = window.navigator.userAgent.match(/Android/i);
        var isBlackBerry = window.navigator.userAgent.match(/BlackBerry/i);
        var isiOS = window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
        var isOpera = window.navigator.userAgent.match(/Opera Mini/i);
        var isIEMobile = window.navigator.userAgent.match(/IEMobile/i);

        return isAndroid && isBlackBerry && isiOS && isOpera && isIEMobile;
    },
    getInternalSources: function () {
        return [
            'search',
            'jobs',
            'post-apply',
            'invitation',
            'job-post-recommendations',
            'dashboard-applications',
            'dashboard-suggestions'
        ];
    },
    getRefererSource: function () {

        var previousUrl = window.referer || '';
        var source = ReferralUtils.data['utm_source'];
        var campaign = null;
        var internalSources = ReferralUtils.getInternalSources();
        var externalSources = [
            'mailchimp',
            'craigslist',
            'indeed_sponsored',
            'indeed',
            'simplyhired',
            'glassdoor_organic',
            'glassdoor',
            'monster',
            'jobs_2_careers',
            'zip_recruiter_sponsored',
            'zip_recruiter',
            'ziprecruiter',
            'adroll',
            'email_daily',
            'email_biweekly',
            'email_other',
            'google_jobs_apply',
            'google',
            'CatererGlobal_UK',
            'caterer',
            'gumtree',
            'leisure_jobs',
            'reed',
            'jooble',
            'adzuna',
            'career_portal_subscription',
            'SnagAJob',
            'CareerBuilder',
            'Poached',
            'Jobs_ie',
            'FinnJobb',
            'HotelCareer',
            'Headhunter',
            'HOSCO_CH',
            'hosco_apply',
            'LinkedIn',
            'HCareers.com',
            'Superjobs',
            'Culintro',
            'CulinaryAgents',
            'eJobs',
            'TuriJobs',
            'Jobindex',
            'Platsbanken',
            'Arbetsformedlingen',
            'applebees',
            'Kariyer_net',
            'hospitality_job_uk',
            'CV_LIBRARY',
            'talent',
            'DUNKIN',
            'FUSED7',
            'TALROO',
            'RestLess_channel',
            'Jobnet_DK',
            'jobswipe'
        ];

        if (source) {
            campaign = ReferralUtils.data['utm_campaign'];
        }
        else if (previousUrl) {
            if (previousUrl.includes('query')) {
                source = 'search';
            } else if (internalSources.includes(previousUrl)) {
                source = previousUrl;
            } else {
                source = getParameterByName('utm_source', previousUrl);

                if (source) {
                    campaign = getParameterByName('utm_campaign', previousUrl);
                }
                else {
                    for (var i in externalSources) {
                        if (previousUrl.toLowerCase().includes(externalSources[i].toLowerCase())) {
                            source = externalSources[i];
                            break;
                        }
                    }
                }
            }
        }

        return {
            'referrer_campaign': campaign,
            'referrer': source && source.toLowerCase(),
            'device_type': ReferralUtils.isMobile() ? 'mobile' : 'desktop'
        };
    }
};